import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarRange, AlertTriangle, CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";
import { Card } from "./ui/card";
import { isoToDisplay } from "./DateInput";

const mingguIni = () => {
  const n = new Date();
  n.setDate(n.getDate() + ((7 - n.getDay()) % 7));
  return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}-${String(n.getDate()).padStart(2, "0")}`;
};

const UTAMA = ["Pembicara", "Tema", "Worship Leader", "PIC Ibadah"];

export const JadwalMingguIniCard = () => {
  const [j, setJ] = useState(null);
  const tgl = mingguIni();
  useEffect(() => { api.get(`/jadwal/${tgl}`).then((r) => setJ(r.data)).catch(() => setJ({ isi: {}, pelayan: [] })); }, [tgl]);
  if (!j) return null;
  const lain = Object.entries(j.isi || {}).filter(([p, v]) => !UTAMA.includes(p) && v);
  const tidak = j.pelayan_tidak_ditemukan || [];
  const cocok = (v) => !tidak.some((n) => (v || "").toLowerCase().includes(n.toLowerCase()));
  const posisiDari = (n) => (Object.entries(j.isi || {}).find(([p, v]) => !["Tema", "Seragam"].includes(p) && (v || "").toLowerCase().includes(n.toLowerCase())) || [""])[0];
  const fixLink = (n) => `/jadwal-pelayanan?tanggal=${tgl}&fokus=${encodeURIComponent(posisiDari(n))}&nama=${encodeURIComponent(n)}`;
  return (
    <Card className="p-4 sm:p-5 rounded-2xl border-slate-200/80" data-testid="dashboard-jadwal-card">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="h-11 w-11 rounded-xl bg-[hsl(224,64%,33%)]/10 text-[hsl(224,64%,33%)] flex items-center justify-center shrink-0"><CalendarRange className="h-5 w-5" /></div>
          <div className="min-w-0">
            <div className="text-xs sm:text-sm text-slate-500">Jadwal Pelayanan Minggu Ini</div>
            <div className="text-base sm:text-lg font-bold text-slate-900" data-testid="dashboard-jadwal-tanggal">Minggu, {isoToDisplay(tgl)}</div>
          </div>
        </div>
        <Link to="/jadwal-pelayanan" className="text-sm font-semibold text-[hsl(224,64%,33%)] hover:underline shrink-0 min-h-[44px] inline-flex items-center" data-testid="dashboard-jadwal-link">Buka Jadwal →</Link>
      </div>
      {j.pelayan.length === 0 && !j.isi?.Tema ? (
        <p className="text-sm text-amber-700 bg-amber-50 rounded-xl px-3 py-2" data-testid="dashboard-jadwal-empty">Jadwal minggu ini belum diisi.</p>
      ) : (
        <div className="space-y-2">
          <dl className="grid grid-cols-2 sm:grid-cols-4 gap-2 text-sm">
            {UTAMA.map((p) => (
              <div key={p} className="rounded-xl bg-slate-50 px-3 py-2 min-w-0" data-testid={`dashboard-jadwal-${p.replace(/\s+/g, "-")}`}>
                <dt className="text-[11px] uppercase tracking-wide text-slate-500">{p}</dt>
                <dd className={`font-semibold truncate ${cocok(j.isi?.[p]) || p === "Tema" ? "text-slate-800" : "text-amber-700"}`}>{j.isi?.[p] || "-"}{!cocok(j.isi?.[p]) && p !== "Tema" && <AlertTriangle className="inline h-3.5 w-3.5 ml-1 -mt-0.5" />}</dd>
              </div>
            ))}
          </dl>
          {lain.length > 0 && (
            <ul className="flex flex-wrap gap-1.5 text-xs" data-testid="dashboard-jadwal-pelayan">
              {lain.map(([p, v]) => <li key={p} className={`px-2 py-1 rounded-full border ${cocok(v) ? "bg-white text-slate-700" : "bg-amber-50 border-amber-300 text-amber-800"}`} data-testid={`dashboard-jadwal-chip-${p.replace(/\s+/g, "-")}`}>{!cocok(v) && <AlertTriangle className="inline h-3 w-3 mr-1 -mt-0.5" />}<span className="text-slate-400">{p}:</span> {v}</li>)}
            </ul>
          )}
          {tidak.length > 0 && (
            <div className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-xl px-3 py-2" data-testid="dashboard-jadwal-warning">
              <AlertTriangle className="inline h-3.5 w-3.5 mr-1 -mt-0.5" />{tidak.length} nama belum cocok dengan Data Jemaat — tidak akan masuk Absensi Doa Persiapan. Klik nama untuk memperbaiki:
              <span className="inline-flex flex-wrap gap-1.5 ml-1 align-middle">
                {tidak.map((n) => <Link key={n} to={fixLink(n)} className="px-2 py-0.5 rounded-full bg-white border border-amber-300 text-amber-900 font-semibold hover:bg-amber-100 min-h-[28px] inline-flex items-center" data-testid={`dashboard-jadwal-fix-${n.replace(/\s+/g, "-")}`}>{n} ({posisiDari(n) || "?"}) →</Link>)}
              </span>
            </div>
          )}
          {tidak.length === 0 && j.pelayan.length > 0 && (
            <p className="text-xs text-emerald-700" data-testid="dashboard-jadwal-ok"><CheckCircle2 className="inline h-3.5 w-3.5 mr-1 -mt-0.5" />Semua {j.pelayan.length} pelayan cocok dengan Data Jemaat.</p>
          )}
        </div>
      )}
    </Card>
  );
};
